
import { useState } from 'react';
import GetInTouchModal from './GetInTouchModal';
import HiringModal from './HiringModal';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [showContact, setShowContact] = useState(false);
  const [showHiring, setShowHiring] = useState(false);

  // Optional: safeguard against unexpected values
  const handleOpenContact = () => {
    try {
      setShowContact(true);
    } catch (error) {
      console.error('Failed to open contact modal:', error);
    }
  };

  const handleCloseContact = () => {
    try {
      setShowContact(false);
    } catch (error) {
      console.error('Failed to close contact modal:', error);
    }
  };

  const handleOpenHiring = () => {
    try {
      setShowHiring(true);
    } catch (error) {
      console.error('Failed to open hiring modal:', error);
    }
  };

  const handleCloseHiring = () => {
    try {
      setShowHiring(false);
    } catch (error) {
      console.error('Failed to close hiring modal:', error);
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-white cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>
                <span className={`transition-colors duration-300 ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                  CADENCE STUDIOS
                </span>
              </a>
            </div>

            <div className="flex items-center gap-4">
              <button
                onClick={handleOpenContact}
                className={`px-6 py-2.5 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap border ${
                  isScrolled
                    ? 'border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'
                    : 'border-white text-white hover:bg-white hover:text-gray-900'
                }`}
              >
                Get in Touch
              </button>
              <button
                onClick={handleOpenHiring}
                className={`px-6 py-2.5 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'bg-gray-900 text-white hover:bg-gray-800'
                    : 'bg-white text-gray-900 hover:bg-gray-100'
                }`}
              >
                We&apos;re Hiring
              </button>
            </div>
          </div>
        </div>
      </nav>

      <GetInTouchModal isOpen={showContact} onClose={handleCloseContact} />
      <HiringModal isOpen={showHiring} onClose={handleCloseHiring} />
    </>
  );
}
